import { render, staticRenderFns } from "./ButtonRecoverPass.vue?vue&type=template&id=4f2c51f0&"
import script from "./ButtonRecoverPass.vue?vue&type=script&lang=js&"
export * from "./ButtonRecoverPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports